import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

// import * as actions from '../../store/actions/index';
import { Col } from 'react-bootstrap';
import ResponsiveWrapper from '../../../components/UI/ResponsiveWrapper/ResponsiveWrapper';
import Kinostyles from '../../../components/Util/AutokinoStylesComponent.module.css';
import * as ROUTES from '../../../constants/routes';


import jurassic_world_die_wiedergeburt_im_kinoAvif from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-im-kino.avif';
import jurassic_world_die_wiedergeburt_im_kinoJpg from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-im-kino.JPG';
import jurassic_world_die_wiedergeburt_im_kinoWebp from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-im-kino.webp';

import jurassic_world_die_wiedergeburt_kinoprogramm_2025Avif from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-kinoprogramm-2025.avif';
import jurassic_world_die_wiedergeburt_kinoprogramm_2025Jpg from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-kinoprogramm-2025.JPG';
import jurassic_world_die_wiedergeburt_kinoprogramm_2025Webp from '../../../assets/images/autokino/landingpages/jurassic-world-die-wiedergeburt-kinoprogramm-2025.webp';

import MovieReminderSubscriptionForm from '../../../components/MovieReminderSubscriptionForm/MovieReminderSubscriptionForm';
import CTAButton from '../../../components/UI/LPTemplates/CTAButton';
import H1FlohmarktSchrift from '../../../components/UI/LPTemplates/H1FlohmarktSchrift';
import H2FlohmarktSchrift from '../../../components/UI/LPTemplates/H2FlohmarktSchrift';
import H3FlohmarktSchrift from '../../../components/UI/LPTemplates/H3FlohmarktSchrift';
import H4FlohmarktSchrift from '../../../components/UI/LPTemplates/H4FlohmarktSchrift';
import LandingPageImage from '../../../components/UI/LPTemplates/LandingPageImage';
import TextBlock from '../../../components/UI/LPTemplates/TextBlock';
import ShowsList from '../../../containers/ShowsList/ShowsList';
import heute_geschlossen_svg from '../../../assets/images/autokino/landingpages/heute_geschlossen1.svg';

const Jurassic_world = props => {
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const [movieId, setMovieId] = useState(463);
  const [formSubmitted, setSubmitted] = useState(false);

  const openModal = () => {
    setModal(!modal);
  };
  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  useEffect(() => {
    props.onFetchMovieDetail(movieId, '');
    props.fetchShows(null);
  }, []);

  const onAddNotification = (e, mess) => {
    e.preventDefault();
    props.onAddNotification(mess);
    console.log(
      'onAddNotification called, reset input flag: ' + props.resetInputs
    );
  };

  const onCheckOutHandler = (e, registerData) => {
    e.preventDefault();
    registerData = {
      ...registerData,
      movieIds: [movieId],
    };
    console.log(
      'onCheckOutHandler called body: ' + JSON.stringify(registerData)
    );
    props.onSaveForm(registerData);
    setSubmitted(true);
  };

  const renderSignupForm = () => {
    if (formSubmitted) {
      return (
        <div className={'m-4'}>
          <b>
            Wir haben deine Email gespeichert, wir informieren dich sobald wir
            den Film im Programm haben
          </b>
        </div>
      );
    } else {
      return (
        <MovieReminderSubscriptionForm
          saveClicked={(e, registerData) => onCheckOutHandler(e, registerData)}
          addNotification={(e, message) => onAddNotification(e, message)}
          data={props.formData}
          loading={props.isLoading}
        />
      );
    }
  };

  const renderUpcomingShows = () => {
    return props.movie.upcomingShows.map((show, index) => {
      return (
        <Col xl={12} xs={12} className={'mt-2'}>
          <div className={Kinostyles.TextContainer + ' mt-2'}>
            {!show.futureSales && !show.soldOut ? (
              <button className={Kinostyles.CTAButton}>
                <a
                  href={ROUTES.MOVIE_SHOW + '/' + show.showUrlIdentifier}
                  className={Kinostyles.CTAButtonLink}
                >
                  {show.showDate} - {show.startTime}
                </a>
              </button>
            ) : show.soldOut ? (
              <button className="btn btn-first btn-disabled">
                {show.showDate} - Ausverkauft
              </button>
            ) : (
              <button className="btn btn-first btn-disabled">
                {show.showDate} - Verkauf in Kürze
              </button>
            )}
          </div>
        </Col>
      );
    });
  };
  //console.log('render cat = ' + props.shows.length);
  return (
    <div>
      <Helmet defer={false}>
        <title>
          🦕 Jurassic World: Die Wiedergeburt im Kino. #Kinoprogramm
        </title>
        <meta
          name="description"
          content="🦕 Jurassic World: Die Wiedergeburt bringt das Dino-Abenteuer zurück ins Kino! Erfahre alles zu Starttermin, Trailer & FSK-Altersfreigabe!"
        />
        <meta
          name="keywords"
          content="Jurassic Worlddie Wiedergeburt, Jurassic World Rebirth, Jurassic World Kinoprogramm, Jurassic World im Kino, Jurassic World Trailer"
        />

        <link
          rel="canonical"
          href="https://www.autokino.at/kinoprogramm-wien/jurassic-world-die-wiedergeburt"
        />
      </Helmet>
      <div>
        <ResponsiveWrapper>
          <LandingPageImage
            avifImage={jurassic_world_die_wiedergeburt_im_kinoAvif}
            webpImage={jurassic_world_die_wiedergeburt_im_kinoWebp}
            jpegImage={jurassic_world_die_wiedergeburt_im_kinoJpg}
            halfSize={true}
            title={'Jurassic World 2025 die Wiedergeburt im Kino'}
            altText={'2025 im Kino. Jurassic World die Wiedergeburt'}
          />
          <H1FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={
              'Jurassic World: Die Wiedergeburt – Kinostart, Trailer & Details'
            }
          />
          <TextBlock
            text="Dein episches Kinoerlebnis erwartet dich! 🌟 <b>#DinosUnterSternen</b>
          <br />
          <br />
          Hier findest du alle wichtigen Informationen zum mit Spannung erwarteten <a href='https://autokino.at/kino/open-air-kino'> Kinoblockbuster im Sommer</a> - Jurassic World: Die Wiedergeburt (2025).
           "
          />
          <br />
          <H2FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={
              'Wann startet "Jurassic World: Die Wiedergeburt" in Österreich?'
            }
          />
          <TextBlock
            text='Laut Universal Pictures kommt der Film "Jurassic World: Die Wiedergeburt" am 2. Juli 2025 in die österreichischen Kinos! 🎟
          <br />
          Man erwartet, dass dieser Film einer der größten Kinohits des Jahres wird.🔥'
          />
          <br />
          {!props.movie ||
            !props.movie.upcomingShows ||
            props.movie.upcomingShows.length < 1 ? (
            <>
              <br />
              <H3FlohmarktSchrift
                color={'yellow'}
                centered={false}
                text={'Offizieller Trailer zu Jurassic World 2025'}
              />
              <br />
              <iframe
                className="modal__video-style"
                onLoad={spinner}
                loading="lazy"
                width="95%"
                height="600px"
                src={
                  'https://www.youtube.com/embed/jQ8OlnyLZJM?si=Rs4z1bgUdfnX23Jo'
                }
                title="YouTube Trailer Jurassic World: Die Wiedergeburt - deutsch"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen"
              />

              <H3FlohmarktSchrift
                color={'yellow'}
                centered={false}
                text={'Wann läuft das Dinosaurier Abenteuer im Autokino?'}
              />
              <TextBlock
                text="Aktuell stehen wir mit Universal Pictures in Kontakt, um herauszufinden, ab wann wir den Film zeigen dürfen. 🎬
              <br />
              <br />
              Falls wir ihn bereits in Mindestspielzeit anbieten dürfen, könnte der Film schon ab 2.7.2025 starten! Andernfalls ist eine Vorstellung meist erst ab der 4. Spielwoche möglich.
              <br />
              <br />
              Melde dich mit deiner E-Mail an und wir informieren dich, sobald der Film bei uns läuft!"
              />
              <br />
              <br />
              {renderSignupForm()}
            </>
          ) : (
            ''
          )}

          {props.movie &&
            props.movie.upcomingShows &&
            props.movie.upcomingShows.length > 0 ? (
            <>
              <H2FlohmarktSchrift
                color={'yellow'}
                centered={false}
                text={
                  'Kinoprogramme & Spielzeiten den Jurassic World - Die Wiedergeburt'
                }
              />
              <TextBlock text="Genieße einzigartige Autokino Atmosphäre mit diesem epischen Dino-Blockbuster! 🦖" />
              <br />
            </>
          ) : (
            ''
          )}
          {props.movie &&
            props.movie.upcomingShows &&
            props.movie.upcomingShows.length > 0
            ? renderUpcomingShows()
            : ''}
          <br />
          <H2FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={
              'Das aktuelle Kinoprogramm im Autokino Wien'
            }
          />
          <br />
          {/* <TextBlock
            text="
                 Hier geht´s zu unserem <a href='https://autokino.at/kinoprogramm-wien/'>aktuellen Kinoprogramm. </a> 
                 "
          /> */}
          {props.shows && props.shows.length > 0 ? (
            <ShowsList shows={props.shows} />
          ) : (
            <LandingPageImage
              jpegImage={heute_geschlossen_svg}
              halfSize={true}
              title={'Heute geschlossen '}
              altText={
                'Heute haben wir leider geschlossen. Bitte schau in unserem Kinoprogramm nach, wann wir unseren nächsten Spieltag haben.'
              }
            />
          )}

          <H3FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Filmlänge des Dinosaurier Movie'}
          />
          <TextBlock
            text="
        Die offizielle Filmlänge ist noch nicht bestätigt. 🎥
        Geschätzt wird aber eine Dauer von ca. 2 Stunden. ⏳
        "
          />
          <H3FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'FSK & Altersfreigabe in Österreich'}
          />
          <TextBlock
            text="
        Die FSK-Freigabe steht noch nicht fest. 🎫
 <br />
        Vermutet wird eine Altersfreigabe ab 12 Jahren oder höher.
        "
          />

          <br />
          <LandingPageImage
            avifImage={jurassic_world_die_wiedergeburt_kinoprogramm_2025Avif}
            webpImage={jurassic_world_die_wiedergeburt_kinoprogramm_2025Webp}
            jpegImage={jurassic_world_die_wiedergeburt_kinoprogramm_2025Jpg}
            halfSize={true}
            title={'Reviews'}
            altText={'Reviews'}
          />
          <br />
          <H3FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Handlung von Jurassic World: Die Wiedergeburt'}
          />
          <TextBlock
            text="In einer Welt, in der Dinosaurier und Menschen gezwungen sind, nebeneinander zu leben, steht das Gleichgewicht auf der Kippe. 🌍
          <br />
          <br />
          Eine Gruppe von Forschern entdeckt eine bisher unbekannte, hochintelligente Dinosaurierspezies. Doch dunkle Mächte wollen sie für ihre eigenen Zwecke nutzen... ⚠️🔥
          <br />
          <br />
          Während das Team ums Überleben kämpft, droht eine viel größere Gefahr, die gesamte Menschheit zu verschlingen. 🦖💥"
          />
          <br />
          <H4FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Originaltitel: Jurassic World: Rebirth'}
          />
          <br />
          <H3FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Schauspieler & Regie'}
          />
          <H4FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Schauspieler'}
          />
          <TextBlock
            text="
          Zora Bennett – Scarlett Johansson
          <br />
Dr. Henry Loomis – Jonathan Bailey
<br />
Duncan Kincaid – Mahershala Ali
<br />
Rupert Friend, Manuel Garcia-Rulfo, Luna Blaise, Ed Skrein
          "
          />
          <br />
          <H4FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Regie'}
          />
          <TextBlock text="Regisseur: Gareth Edwards (Godzilla, Rogue One)" />
          <br />
          <H3FlohmarktSchrift
            color={'yellow'}
            centered={false}
            text={'Weitere Top-Filme 2025!'}
          />
          <TextBlock
            text="
          <b><a href='https://www.autokino.at/kinoprogramm-wien/fantastic-four'>• Fantastic Four: The first steps</a></b>
          <br />
          <b><a href='https://www.autokino.at/kinoprogramm-wien/die-schluempfe-der-grosse-kinofilm'>• Die Schlümpfe: Der große Kinofilm </a></b>
          <br />          
          <b><a href='https://www.autokino.at/kinoprogramm-wien/F1-der-film-kino'>• F1 - der Film </a></b>
          <br />
          <b><a href='https://www.autokino.at/kinoprogramm-wien/superman-legacy'>• Superman: Legacy</a></b>
          <br />
          <b><a href='https://www.autokino.at/kinoprogramm-wien/die-gangster-gang-2'>• Die Gangster Gang 2</a></b>
          "
          />
          <br />

          <CTAButton
            text={'Zum Kinoprogramm'}
            url={ROUTES.LANDING}
            centered={true}
            color={'pink'}
          />
          <br />
        </ResponsiveWrapper>
      </div>
    </div>
  );
};

Jurassic_world.propTypes = {
  movie: PropTypes.object,
  loading: PropTypes.bool,
  forceReload: PropTypes.bool,
  error: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  fetchShows: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    movie: state.movie.movie,
    loading: state.movie.loading,
    forceReload: state.movie.forceReload,
    error: state.movie.error,
    shows: state.shows.shows,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchMovieDetail: (id, identifier) =>
      dispatch(actions.fetchMovieDetail(id, identifier)),
    onSaveForm: data => dispatch(actions.saveMovieReminderSubscription(data)),
    onAddNotification: mess => dispatch(actions.addNotification(mess)),
    fetchShows: (showIdentifier) => dispatch(actions.fetchShows(showIdentifier))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Jurassic_world);
